<template>


  <div class="input-field">

    <sc-field
      :label="label"
      :message="message"
      :type="message ? 'is-danger' : ''"
    >
      <sc-input
        v-if="fieldSchema.type == 'password'"
        v-model="inputFieldValue"
        :placeholder="fieldSchema.placeholder"
        @blur="updateInputValue"
        type="password"
        password-reveal
      />
      <sc-input
        v-else
        v-model="inputFieldValue"
        :placeholder="fieldSchema.placeholder"
        @blur="updateInputValue"
      />
    </sc-field>

  </div>


</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScField,
  ScInput,
  ScButton,
  ScTooltip,
} from "@intelipost-js/secure-components";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-modal-config-string-field",

  props: {
    fieldSchema: {
      type: Object
    }
  },

  data() {
    return {
      label: "",
      message: "",
      inputFieldValue: ""
    }
  },

  computed: {
    ...mapState(["appConfigUpdated"]),
  },

  mounted() {
    this.label = this.fieldSchema.title;
    if (!this.label) this.label = this.fieldSchema.name;
    this.label += this.fieldSchema.required ? ' (Obrigatório)' : ' (Opcional)';

    this.inputFieldValue = this.appConfigUpdated[this.fieldSchema.name];
  },

  methods: {

    ...mapActions([
      "updateAppConfig",
    ]),

    updateInputValue() {

       this.validate();

      const appConfig = {
        ...this.appConfigUpdated,
      }

      appConfig[this.fieldSchema.name] = this.inputFieldValue

      this.updateAppConfig(appConfig)

    },

    validate() {
      if (this.fieldSchema.required && !this.inputFieldValue) {

        this.message = 'O preenchimento do campo é obrigatório';
        return false;

      }

      this.message = '';
      return true;
    }
  },

  components: {
    ScButton,
    ScField,
    ScInput,
    ScTooltip,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.input-field {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/components/StringField.vue